import { Box, Modal, SxProps, Theme } from "@mui/material";
import React from "react";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    paddingTop: 4,
    transform: 'translate(-50%, -50%)',
    maxWidth: 400,
    maxHeight: '80vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    pt: 2,
    px: 4,
    pb: 3,
  };
 

const ModalCompontent = ({ open, onClose, children, style: _style}: {open: boolean, onClose: () => void, style?:  {maxWidth?: number}} & React.PropsWithChildren) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
        >

            <Box sx={{
                ...style,
                ..._style
            }}>
                {children}
            </Box>
        </Modal>
    )
}

export default ModalCompontent;